import * as _4 from 'lodash4';
import { IPlacementLocation } from './../interfaces/todo_interface';

export class PathDetailLocationService {
  constructor(private $window: ng.IWindowService) {}

  private get googleMapsBaseUrl(): string {
    if (this.$window.ionic && this.$window.ionic.Platform.isAndroid()) {
      return 'geo://maps.google.com/?q=';
    } else if (this.$window.ionic && this.$window.ionic.Platform.isIOS()) {
      return 'maps://maps.apple.com/?q=';
    } else {
      return 'https://maps.google.com/?q=';
    }
  }

  getFormattedLocations(locations: IPlacementLocation[]): IPlacementLocation[] {
    const mapBaseUrl = this.googleMapsBaseUrl;
    return _4.map(
      _4.filter(locations, (location: IPlacementLocation) => !_4.isEmpty(location.address)),
      (location: IPlacementLocation) => {
        return {
          properties: location.properties,
          name: location.properties.name,
          link: mapBaseUrl + location.address,
          address: location.address,
          comments: location.comments
        };
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/task_detail_location_service.ts